(() => {
  const prepared = new WeakSet();
  const visible = (video) => {
    const rect = video.getBoundingClientRect();
    return video.isConnected && !document.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  };
  const play = (video) => {
    if (!visible(video)) return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  };
  const visibility = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) play(target);
    });
  });
  const prepare = (video) => {
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    video.disableRemotePlayback = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('tabindex', '-1');
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
    if (prepared.has(video)) {
      visibility.observe(video);
      play(video);
      return;
    }
    prepared.add(video);
    video.addEventListener('pause', () => play(video));
    video.addEventListener('canplay', () => play(video));
    visibility.observe(video);
    play(video);
  };
  const scan = (root) => {
    if (root instanceof HTMLVideoElement) prepare(root);
    if (root.querySelectorAll) root.querySelectorAll('video').forEach(prepare);
  };
  scan(document);
  new MutationObserver((changes) => {
    changes.forEach((change) => {
      if (change.type === 'attributes') {
        if (change.target.hasAttribute('controls')) change.target.controls = false;
      } else {
        change.addedNodes.forEach(scan);
        change.removedNodes.forEach((root) => {
          if (root instanceof HTMLVideoElement) visibility.unobserve(root);
          if (root.querySelectorAll) root.querySelectorAll('video').forEach(video => visibility.unobserve(video));
        });
      }
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['controls'] });
  const resume = () => document.querySelectorAll('video').forEach(play);
  document.addEventListener('visibilitychange', resume);
  document.addEventListener('pointerdown', resume, { passive: true });
  document.addEventListener('keydown', resume);
  window.addEventListener('pageshow', resume);
})();
